var _a;
import { __decorate, __metadata } from "tslib";
import { Component, Emit, Prop } from 'vue-property-decorator';
import { calculateTextColor } from '../utils/helpers/colors';
import BaseVue from './BaseVue';
let BaseButton = class BaseButton extends BaseVue {
    color;
    disabled;
    href;
    icon;
    iconSize;
    isSaving;
    showLoader;
    small;
    textColor;
    to;
    get computedColor() {
        return this.color || '--v-primary-base';
    }
    get computedDisabled() {
        return this.showLoader || this.isSaving || this.disabled;
    }
    get computedIconColor() {
        return this.computedTextColor;
    }
    get computedIconSize() {
        if (this.small) {
            return this.iconSize || '18px';
        }
        return this.iconSize || '22px';
    }
    get computedTextColor() {
        return this.textColor || calculateTextColor(this.computedColor);
    }
    // Vuetify has an identically named prop called "icon" and we dont use that fncality
    // so remove it so it stops doing weird ui things
    get propsWithoutIcon() {
        const obj = Object.assign({}, this.$props);
        delete obj.icon;
        return obj;
    }
    // can't pass both href and to props, so we need to delete one if the other exists. Only one may pass!!!
    get computedProps() {
        const obj = Object.assign({}, this.$props);
        if (obj.to) {
            delete obj.href;
        }
        else if (obj.href) {
            delete obj.to;
        }
        return obj;
    }
    onClick(cClick) {
        if (this.to) {
            cClick?.detail.preventDefault();
            if (cClick?.detail.metaKey) {
                window.open(this.to.toString());
                return;
            }
            this.$router.push(this.to);
            return;
        }
        this.emitClick(cClick?.detail);
    }
    emitClick(event) { }
};
__decorate([
    Prop({
        type: String
    }),
    __metadata("design:type", String)
], BaseButton.prototype, "color", void 0);
__decorate([
    Prop({
        default: false,
        type: Boolean
    }),
    __metadata("design:type", Boolean)
], BaseButton.prototype, "disabled", void 0);
__decorate([
    Prop({
        default: '',
        type: String
    }),
    __metadata("design:type", String)
], BaseButton.prototype, "href", void 0);
__decorate([
    Prop({
        type: String
    }),
    __metadata("design:type", String)
], BaseButton.prototype, "icon", void 0);
__decorate([
    Prop({
        type: String
    }),
    __metadata("design:type", String)
], BaseButton.prototype, "iconSize", void 0);
__decorate([
    Prop({
        default: false,
        type: Boolean
    }),
    __metadata("design:type", Boolean)
], BaseButton.prototype, "isSaving", void 0);
__decorate([
    Prop({
        type: Boolean,
        default: false
    }),
    __metadata("design:type", Boolean)
], BaseButton.prototype, "showLoader", void 0);
__decorate([
    Prop({
        type: Boolean,
        default: false
    }),
    __metadata("design:type", Boolean)
], BaseButton.prototype, "small", void 0);
__decorate([
    Prop({
        type: String
    }),
    __metadata("design:type", String)
], BaseButton.prototype, "textColor", void 0);
__decorate([
    Prop({
        default: '',
        type: [String, Location, Object]
    }),
    __metadata("design:type", Object)
], BaseButton.prototype, "to", void 0);
__decorate([
    Emit('click'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_a = typeof MouseEvent !== "undefined" && MouseEvent) === "function" ? _a : Object]),
    __metadata("design:returntype", void 0)
], BaseButton.prototype, "emitClick", null);
BaseButton = __decorate([
    Component
], BaseButton);
export default BaseButton;
